import { NgFor } from '@angular/common';
import { Component, HostBinding, Input } from '@angular/core';

import { ColoredIconComponent } from './colored-icon.component';

@Component({
    selector: 'ms-multiple-flags',
    templateUrl: './multiple-flags.component.html',
    imports: [ColoredIconComponent, NgFor],
})
export class MultipleFlagsComponent {
    @Input() regionIds: number[];
    @HostBinding('class') className = 'multiple-flags';
}
